import { render, staticRenderFns } from "./EmployeePayslip.vue?vue&type=template&id=9ffd74a8&scoped=true"
import script from "./EmployeePayslip.vue?vue&type=script&lang=js"
export * from "./EmployeePayslip.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9ffd74a8",
  null
  
)

export default component.exports